var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.80037 7.62935V10.5695C9.80037 13.0196 8.82033 13.9996 6.37024 13.9996H3.43013C0.980037 13.9996 0 13.0196 0 10.5695V7.62935C0 5.17926 0.980037 4.19922 3.43013 4.19922H6.37024C8.82033 4.19922 9.80037 5.17926 9.80037 7.62935Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M10.5703 0H7.63018C5.21506 0 4.23503 0.959036 4.20703 3.32513H6.37013C9.31025 3.32513 10.6753 4.69018 10.6753 7.63029V9.79337C13.0414 9.76537 14.0004 8.78533 14.0004 6.37024V3.43013C14.0004 0.980037 13.0204 0 10.5703 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyWhite);
export default __webpack_public_path__ + "static/media/copy-white.b43ad891a70b9589ca470eaae0668932.svg";
export { ForwardRef as ReactComponent };